import { StyledDropdownButton } from "./style";

const DropdownButton = ({
  items,
  buttonText,
  handleItemClicked,
  onButtonClick,
  disabled = false,
  ...rest
}) => {
  const menuProps = {
    items,
    onClick: handleItemClicked,
  };

  return (
    <StyledDropdownButton
      color="primary"
      type="primary"
      menu={menuProps}
      onClick={onButtonClick}
      disabled={disabled}
      {...rest}
    >
      {buttonText}
    </StyledDropdownButton>
  );
};

export default DropdownButton;
